// @ts-nocheck

import { createSelector } from 'reselect';

import { type SelectorMaker } from '../../../../types/selectors';
import { selectBoomStepsOrderState } from '../../selectors/stepsOrder/stepsOrderPrimary.selector';
import { selectBoomUserProgress } from '../../selectors/user/userPrimary.selector';

const getStepNumberFromProps = (_, { stepId }: { stepId: string }) => stepId ?? null;

const emptyObj = {};

type BoomStepViewBetslipRefType = {
  betslipReference: string;
  stepIndex: number;
};

const makeBoomStepViewBetslipRefSelector: SelectorMaker<BoomStepViewBetslipRefType> = () => {
  const selectBoomUserStepProgress = createSelector(
    [selectBoomUserProgress, getStepNumberFromProps],
    (progress, stepId) => progress[stepId] ?? emptyObj,
  );

  const selectBoomStepIndex = createSelector([selectBoomStepsOrderState, getStepNumberFromProps], (stepOrder, stepId) =>
    stepOrder.indexOf(stepId),
  );

  return createSelector([selectBoomUserStepProgress, selectBoomStepIndex], (step, stepIndex) => ({
    betslipReference: step.betslipReference,
    stepIndex,
  }));
};

export default makeBoomStepViewBetslipRefSelector;
